module.exports = __webpack_public_path__ + "static/media/doublemillionaireLogo.d6d68fae.png";